<template>
  <div class="m-solution">
    <!-- <img class="m-page-banner" src="../../assets/images/solution_banner.jpg" alt=""> -->
    <div class="m-page-banner"></div>
    <div class="m-solution-content">
      <div class="m-solution-item" v-for="(item, index) in solutionList" :key="index">
        <div class="item-title-wrap">
          <img class="item-img" :src="item.imgUrl" alt="">
          <p class="item-title" v-html="item.title" :style="'color:' + item.color"></p>
        </div>
        <div class="item-content" :class="item.isExpand ? '' : 'unexpand-content'">{{item.content}}</div>
        <div class="item-expand-btn" @click="toggleItem(item)">{{item.isExpand ? '收起' : '展开'}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import scrollreveal from 'scrollreveal'
export default {
  data () {
    return {
      solutionList: [{
        title: '基于“三个课堂”的<br/>区域教育优质均衡解决方案',
        imgUrl: require('../../assets/images/mImg/solution/solution_1.png'),
        content: '“基于‘三个课堂’的区域教育优质均衡解决方案”是以智慧教育云平台为依托，以优质教育共建共享为基础，以实现教育均衡、达成智慧教学、促进教师发展为目标，以模块化多层级灵活部署为特色，以“交付即开始”的运维服务为保障的成熟解决方案；是助力市（州）、区（县、旗）实现区域教育优质均衡及高质量发展的综合解决方案。',
        isExpand: false,
        color: '#000000'
      }, {
        title: '数据驱动下的<br/>智慧课堂精准教学',
        imgUrl: require('../../assets/images/mImg/solution/solution_2.png'),
        content: '“爱学派”云课堂是在“平台、课堂模型和教研服务”支持下，通过构建个性化、智能化、数字化的学习环境，变革教与学的方式方法，将信息技术深度融合于课堂教学中，实现学习内容精髓化、学习过程智能化、评价反馈及时化、教学过程数据化的智慧课堂解决方案。',
        isExpand: false,
        color: '#0463C0'
      }, {
        title: '基于“专递课堂”的<br/>教育均衡解决方案',
        imgUrl: require('../../assets/images/mImg/solution/solution_3.png'),
        content: '“专递课堂”针对薄弱学校和教学点缺少师资，开不足开不好国家规定课程的问题，通过网络专门开课或者同步上课，将优质教育同步到教育薄弱地区，使课程“开不齐，开不足、开不好”的问题得到根本改变，促进教育公平和均衡发展。该解决方案具体以“同步课堂、双师课堂、空中课堂”等形式来体现。',
        isExpand: false,
        color: '#0CA1C9'
      }, {
        title: '“双减”背景下的<br/>智慧作业解决方案',
        imgUrl: require('../../assets/images/mImg/solution/solution_4.png'),
        content: '“爱学”智慧作业是响应国家政策，立足提升教学质量，根据学校真实作业场景，通过平台布置分层、弹性和个性化作业，将日常作业流程信息化、统计分析数字化、反馈指导及时化，为教师提供教学策略改进的依据，充分发挥作业的巩固、测试、学情分析的作用，实现减负增效。',
        isExpand: false,
        color: '#4BA65F'
      }, {
        title: '基于“名师课堂”的<br/>教研共同体应用方案',
        imgUrl: require('../../assets/images/mImg/solution/solution_5.png'),
        content: '依托20多年积累的优质教育积淀和实践经验，搭建智能网络教研平台，利用大数据技术将教师教学行为进行收集与分析，再结合AI课例分析等先进技术手段，促进区域教师研修共同体的形成和持续发展，建设数据驱动的线上线下相结合的教研新生态，创建教师专业发展新路径，是提升教师综合素质的解决方案。',
        isExpand: false,
        color: '#FAC72E'
      }, {
        title: '基于“名校网络课堂”的<br/>优质教育共建共享解决方案',
        imgUrl: require('../../assets/images/mImg/solution/solution_6.png'),
        content: '结合教育信息化推广实施的经验和区域教育发展的现状，创新优质教育供给形式，构建“以用促建、共建共享”优质教育新生态的解决方案。旨在激活当地教育共建共享，实现“名校网络课堂”建设，缩小区域（城乡、校级）教育质量差距，助力教育优质均衡发展。',
        isExpand: false,
        color: '#E77325'
      }, {
        title: '基于考试数据的<br/>教学评价及改进方案',
        imgUrl: require('../../assets/images/mImg/solution/solution_7.png'),
        content: '利用现代信息技术手段，通过对考试测评数据进行专业化分析，获取可参考信息，发现可解决问题，再经过专业教研员、骨干教师的教研支持和本地教师的教研活动，持续改进教与学方式方法的教学改进方案；是指向学生学业质量发展和教师教学水平提升的、可落地实施的教学改进方案；是“工具+服务+教研”三位一体的教学改进方案。',
        isExpand: false,
        color: '#B22B2E'
      }]
    }
  },
  mounted() {
    this.$nextTick(() => {
      let that = this
      setTimeout(() => {
        that.setAnimation()
      }, 100)
    })
  },
  methods: {
    toggleItem(item) {
      item.isExpand = !item.isExpand
      this.setAnimation()
    },
    // 动画
    setAnimation() {
      scrollreveal().reveal('.m-solution .m-solution-item', {
        duration: 1500, //动画的时长
        origin: 'bottom', //动画开始的位置，'bottom', 'left', 'top', 'right'
        reset: true, //回滚的时候是否再次触发动画
        mobile: true, //在移动端是否使用动画
        distance: '40px', //滚动的距离，单位可以用%，rem等
        easing: 'ease-in-out'
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.m-solution {
  width: 100%;
  .m-page-banner {
    width: 100%;
    display: block;
    height: 4.5rem;
    background: url('../../assets/images/solution_banner.jpg') no-repeat;
    background-position: center top;
    background-size: cover;
  }
  .m-solution-content {
    width: 100%;
    margin-top: .36rem;
    margin-bottom: 1.2rem;
    .m-solution-item {
      position: relative;
      width: 6.5rem;
      padding: .32rem .26rem .95rem;
      background: #FFFFFF;
      box-shadow: .11rem .14rem .38rem .2rem rgba(61, 61, 61, 0.2);
      border-radius: .1rem;
      margin: 0 auto;
      margin-top: .64rem;
      .item-title-wrap {
        display: flex;
        font-size: .33rem;
        font-weight: 400;
        line-height: .42rem;
        .item-img {
          width: 1.74rem;
          height: 2.4rem;
          margin-right: .2rem;
        }
        .item-title {
          margin-top: .52rem;
        }
      }
      .item-content {
        font-size: .29rem;
        font-weight: 300;
        color: #595757;
        line-height: .50rem;
        margin-top: .26rem;
        text-align: justify;
        padding: 0 .06rem;
      }
      .unexpand-content {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .item-expand-btn {
        position: absolute;
        right: .36rem;
        bottom: .36rem;
        font-size: .25rem;
        font-weight: 400;
        color: #217CFE;
      }
    }
  }
}
</style>